import React from 'react';
import { Header4, Paragraph2, RealtorHonest16, TooltipDesktop } from '@cian/ui-kit';

import styles from './HonestRealtor.css';
import { ContentRow } from '../ContentRow';

interface IHonestRealtorProps {
  text?: string;
}

export function HonestRealtor({ text }: IHonestRealtorProps) {
  return (
    <TooltipDesktop
      theme="white"
      title={
        <div className={styles['tooltip']} onClick={e => e.stopPropagation()}>
          <ContentRow size={'M'}>
            <Header4>Проверено Циан</Header4>
          </ContentRow>
          <ContentRow size={'M'}>
            <Paragraph2>Служба контроля качества регулярно проверяет объявления данного агента.</Paragraph2>
          </ContentRow>
          <a href={'https://promo.cian.ru/rabotayu-chestno'} target="_blank">
            Узнать подробнее
          </a>
        </div>
      }
      placement="left"
    >
      <div className={styles['cont']}>
        <RealtorHonest16 color="primary_100" />
        {text && <span className={styles['text']}>{text}</span>}
      </div>
    </TooltipDesktop>
  );
}
